<template>
    <div class="component-wrapper">
        <div :class="active ? 'filter-component-container-active' : 'filter-component-container'">
            <div class="filter-controls-upper">
                <div @click="toggleFilter" :class="active ? 'filter-btn-active' : 'filter-btn'">
                    <span class="text">Фильтры</span>
                    <svg v-if="!active" class="icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <svg v-else class="icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12.5L10 7.5L15 12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div v-if="activeFilters && !active" class="active-filters">
                        {{ activeFilters }}
                    </div>
                </div>
                <Transition name="fade">
                    <button v-if="activeFilters && active" @click="clearSelects" class="btn-cancel">Сбросить</button>
                </Transition>
            </div>

            <div class="filter-wrapper">
                <div class="filter-selects mb-3">
                    <div v-for="filter in localFilters">
                        <v-select v-if="filter.type === 'select'"
                                  :label="filter.name"
                                  v-model="filter.model"
                                  :items="filter.options"
                                  :item-title="filter.name === 'Версия' ? 'number' : 'name'"
                                  item-value="id"
                                  variant="outlined"
                                  color="primary"
                                  density="compact"
                                  clearable
                                  @update:menu="$removeFocus"
                                  @click:clear="$removeFocus"
                                  @click:control="$removeFocus">
                            <template #no-data>
                                <span>Данные не найдены</span>
                            </template>
                        </v-select>

                        <input v-else-if="filter.type === 'date'" v-model="filter.model"
                               class="form-control"
                               type="date">

                        <input v-else-if="filter.type === 'time'" v-model="filter.model"
                               class="form-control"
                               type="time">

                        <div v-else-if="filter.type === 'interval'">
                            <label class="form-label">Интервал времени</label>
                            <div class="time-interval-inputs">
                                <input type="time" class="form-control" placeholder="От" v-model="filter.model.from">
                                <input type="time" class="form-control" placeholder="До" v-model="filter.model.to">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-controls">
                    <button @click="applyFilter" class="btn-primary btn">Применить</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'FilterComponent',
    props: {
        filters: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            active: false,
            localFilters: null,
            appliedFilters: null,
            activeFilters: null
        }
    },

    methods: {
        ...mapMutations('filterComponent', ['setFilterState']),

        toggleFilter() {
            if (!this.active) {
                this.localFilters = this.appliedFilters.map(filter => ({ ...filter }));
            }
            this.active = !this.active;
        },

        applyFilter() {
            // Сворачиваем фильтр
            this.active = false;

            // Сохраняем применённые фильтры
            this.appliedFilters = this.localFilters.map(filter => ({ ...filter }));

            // Записываем примененные фильтры в store
            this.setFilterState(this.appliedFilters);

            // Прогоняем примененные фильтры через массив соответствия
            const filterData = this.transformFilters(this.appliedFilters);

            // Передаем в родительский компонент событие применения фильтров и данные
            this.$emit('filterApplied', filterData);

            // Считаем количество активных фильтров
            this.activeFilters = 0;
            this.appliedFilters.forEach(filter => {
                if (filter.model) this.activeFilters += 1;
            });
        },

        transformFilters(filters) {
            const nameToProp = {
                'Клиент': 'selectedClient',
                'Бренд': 'selectedBrand',
                'Тип устройства': 'selectedDeviceType',
                'Версия': 'selectedVersion',
                'Тип версии': 'selectedVersionType',
                'ПО': 'selectedSoftware',
                'ОС': 'selectedDeviceOperatingSystem',
                'Дата': 'date',
                'Дата выхода': 'date',
                'Отправитель': 'selectedSender',
                'Статус': 'selectedStatus'
            };

            const result = {};

            filters.forEach(element => {
                const prop = nameToProp[element.name];
                if (prop) result[prop] = element.model?.id ?? element.model;
            });

            return result;
        },

        clearSelects() {
            this.localFilters.forEach(filter => {
                if (typeof filter.model === 'object' && filter.model !== null) {
                    if ('from' in filter.model || 'to' in filter.model) {
                        filter.model.from = null;
                        filter.model.to = null;
                    } else {
                        filter.model = null;
                    }
                } else {
                    filter.model = null;
                }
            });
            this.$emit('clearSelects');
            this.applyFilter();
        },

        handleClickOutside(event) {
            const wrapper = this.$el;
            const overlayContainer = document.querySelector('.v-overlay-container');
            if (this.active && !wrapper.contains(event.target) && !overlayContainer?.contains(event.target)) this.active = false;
        }
    },

    watch: {
        filters: {
            handler(newValue) {
                if (newValue) {
                    this.appliedFilters = newValue.map(filter => ({ ...filter }));
                    this.localFilters = this.appliedFilters.map(filter => ({ ...filter }));
                }
            },
            immediate: true
        }
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }
}
</script>

<style scoped lang="scss">
.component-wrapper {
    position: relative;
    margin-bottom: 40px;
}

.filter-component-container {
    position: absolute;
    width: 320px;
    padding: 0px 16px 16px 16px;
    transition: 0.2s;
    overflow: hidden;
    background-color: white;
    overflow: unset;
}

.filter-component-container-active {
    position: absolute;
    width: 320px;
    max-height: 100vh;
    padding: 0px 16px 16px 16px;
    box-shadow: 0px 4px 16px rgba(100, 100, 100, 0.2);
    border-radius: 6px;
    transition: 0.2s;
    background-color: white;
    z-index: 20;
}

.filter-btn {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    padding-left: 4px;
    gap: 6px;
    height: 40px;
    max-width: 130px;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    border-radius: 6px;
    background: #F1F6FF;
    cursor: pointer;
    transition: 0.2s;

    &:active {
        opacity: 0.6;
    }

    .text {
        font-weight: 500;
        font-size: 16px;
        color: #0678F4;
    }

    .icon {
        color: #0678F4;
        transition: transform 0.2s;
        pointer-events: none;
    }
}

.filter-btn-active {
    @extend .filter-btn;
    background: none;
}

.active-filters {
    background-color: #0678F4;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    padding: 6px;
    font-weight: 600;
    font-size: 10px;
    text-align: center;
    padding: 1px;
    position: absolute;
    left: 90%;
    top: -18%;
}

.filter-wrapper {
    max-height: 0;
    transition: 0.2s;
    transform-origin: top;
}

.filter-component-container-active .filter-wrapper {
    max-height: 100vh;
    padding-top: 16px;
    transform: scaleY(1);
}

.filter-wrapper {
    transform: scaleY(0);
}

.filter-selects {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.filter-controls {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.filter-controls-upper {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.time-interval-inputs {
    display: flex;
    gap: 12px;
}
</style>
